import React, {Component} from 'react'
import Header from './header.component'
import Footer from './footer.component'

import '../assets/css/layout.css'


type Props = {
  children: React.ReactNode;
};

type State = {
  content: string;
}

export default class Layout extends Component<Props, State>  {
  constructor(props: Props) {
    super(props);

    this.state = {
      content: '',
    };
  }

  componentDidMount() {
  }

  render() {
    return (
      <div className='container'>
        <Header />
          <main>
            {this.props.children}
          </main>
        <Footer />
      </div>
    )
  }
}
